import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Kcc20TokenStaticProfileCacheService } from '../services/tokens/kcc20-token-static-profile-cache.service';
import {
  Kcc20MarketDiscovery,
  Kcc20MarketsDiscoveryQuery,
  Kcc20TradingApiService,
} from '../services/trading/kcc20-trading-api.service';

const DEFAULT_QUERY: Kcc20MarketsDiscoveryQuery = {
  limit: 30,
  offset: 0,
  sortBy: 'volume24hSompi',
  sortDirection: 'desc',
};

@Injectable({ providedIn: 'root' })
export class MarketDiscoveryManager {
  private readonly tradingApi = inject(Kcc20TradingApiService);
  private readonly tokenStaticProfiles = inject(
    Kcc20TokenStaticProfileCacheService,
  );

  loadDiscovery(
    query: Kcc20MarketsDiscoveryQuery = DEFAULT_QUERY,
  ): Observable<Kcc20MarketDiscovery> {
    return this.tradingApi.getMarketDiscovery(query).pipe(
      tap((page) => {
        // Discovery embeds curated metadata — seed once for Markets, token
        // search, and mint search so later Portfolio/Rewards hops skip GETs.
        this.tokenStaticProfiles.putManyFromMarketMetadata(page?.items ?? []);
      }),
    );
  }
}
